import { render, staticRenderFns } from "./VehicleIdles.vue?vue&type=template&id=2ec66079&lang=pug"
import script from "./VehicleIdles.vue?vue&type=script&lang=js"
export * from "./VehicleIdles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports